import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { formatImage } from 'ThreeTerminal_base/publicMethod';
import { h5PageCount } from 'ThreeTerminal_utils';
import InfoTitle from '../infoTitle';

class News extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    onClick = () => {
        const { share_url, weburl, type, comment_id } = this.props.content;

        h5PageCount([
            {
                behavior: 'action',
                type,
                other: {
                    id: comment_id,
                    ref: encodeURIComponent(document.referrer),
                    url: share_url,
                },
            },
        ]);

        if (weburl) {
            window.location.href = weburl;
        }
    };

    render() {
        const { content } = this.props;

        const {
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isComment,
            pageInfo,
            doc_name,
            doc_thumbnail,
            sub_name,
            comment_relation,
            fromPage,
        } = content;

        const infoTitleData = {
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isComment,
            pageInfo,
            sub_name,
            comment_relation,
            fromPage,
        };

        return (
            <React.Fragment>
                <InfoTitle content={infoTitleData} />
                <div className={styles.wrap}>
                    <div className={styles.wrapBox}>
                        <div className={styles.news} onClick={() => this.onClick()}>
                            {doc_thumbnail && (
                                <div className={styles.thumb}>
                                    <div className={styles.pic}>
                                        <img
                                            src={formatImage(doc_thumbnail, 90 * 2, 60 * 2)}
                                            className={styles.imgStyle}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className={styles.metadata}>
                                <div className={styles.title}>
                                    {/* {sub_name && <span className={styles.name}>@{sub_name}：</span>} */}
                                    {doc_name}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(News);
